module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("BaseBall in Denver")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#INAck"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I would like to acknowledge Jay and Alice Sanford, as they were so incredibly gracious and generous with their time. Jay, thank you especially for your immense knowledge of all things Denver and baseball and for being such a warm and loving person. It was a pleasure working with you.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thanks also go to my baseball friends: Eric Absher, Paul Parker, Gino Grasso, Chris Campassi, Trent Kutler, Matthew Jerebker, Roland Hemond, John Thorn, Rob Neyer, Jonah Keri, Maury Wills, Marc Johnson, Bob Burris, Irv Brown, Cory Schwartz, Meredith Wills, Sabra Anknar, coach Gary Bishop, and Bus Campbell.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unless otherwise noted, "), _c('i', [_vm._v("Baseball in Denver")]), _vm._v(" photographs are from Jay Sanford’s collection.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0